// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607230633/js/" + chunkId + "." + {"44":"2ca1f588","225":"8b491d81","481":"fec577e3","486":"48d6aa40","770":"a471df3b"}[chunkId] + ".0.13310885199665412.chunk.js";
};